export default {
  path: '/activate',
  name: 'activate',
  component: () => import('../views/auth/Activate.vue'),
  meta: {
    layout: 'empty',
    public: true
  }
}